"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = function () {
  throw new Error('File system is not available');
};